import React from "react";

import DeclarationsPT from "./publications/DeclarationsPT";
import EP from "./publications/EP";
import Patent from "./publications/Patent";
import SPC from "./publications/SPC";

const PatentDetails = (props) => {
  const details = props.content.details;

  return (
    <>
      <p>{details.types[props.type]?.lines}</p>
      {props.gazettes.map((e, i) => {
        switch (props.type.toLowerCase()) {
          case "patspcfiled":
          case "patspcwithdrawn":
          case "patspcrefused":
          case "patspcdismissed":
          case "patspccontinuationwithdrawn":
          case "patspccontinuationgranted":
          case "patspccontinuationfiled":
          case "patspccontinuationrefused":
          case "patspcgrantedcertificate":
          case "patspcvaliditycorrected":
          case "patspcannul":
          case "patspclapsed":
            return <SPC key={`${props.type}-${i}`} type={props.type} details={details} gazettes={e} i={i} />;
          case "rajoepkaan5":
          case "eprauen":
          case "epkumot":
          case "eptransc1":
          case "eptransc2":
          case "eptransc4":
          case "eptransc3":
          case "eptransc7":
          case "rajoepkaan":
            return <EP key={`${props.type}-${i}`} type={props.type} details={details} gazettes={e} i={i} />;
          case "tiedan":
            return <DeclarationsPT key={`${props.type}-${i}`} details={details} gazettes={e} />;
          default:
            return <Patent key={`${props.type}-${i}`} type={props.type} details={details} gazettes={e} i={i} />;
        }
      })}
    </>
  );
};

export default PatentDetails;
